// Fix for cart drawer scroll locking - remove scroll lock when drawer closes
(function() {
  'use strict';

  function forceRemoveScrollLock() {
    // Remove scroll lock classes
    document.documentElement.classList.remove('scroll-lock', 'no-scroll');
    document.body.classList.remove('scroll-lock', 'no-scroll');

    // Reset overflow styles
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';

    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
  }

  function initCartDrawerFix() {
    const drawerElement = document.querySelector('#cart-drawer');
    const closeButton = document.querySelector('[data-cart-drawer-close]');

    if (!drawerElement || !closeButton) {
      setTimeout(initCartDrawerFix, 500);
      return;
    }

    // Only remove scroll lock when close button is clicked
    closeButton.addEventListener('click', function() {
      // Remove scroll lock immediately and at intervals
      forceRemoveScrollLock();
      setTimeout(forceRemoveScrollLock, 50);
      setTimeout(forceRemoveScrollLock, 100);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerFix);
  } else {
    initCartDrawerFix();
  }
})();
